var map = {
	"./fortuneIcon.svg": 668,
	"./fortuneIconL.svg": 669,
	"./helpdeskIcon.svg": 670,
	"./helpdeskIconL.svg": 671,
	"./homeIcon.svg": 672,
	"./homeIconLarge.svg": 673,
	"./jackpotIcon.svg": 674,
	"./logo.svg": 675,
	"./logoSmall.svg": 676,
	"./loyaltyIcon.svg": 677,
	"./mobileAppIcon.svg": 678,
	"./profileIcon.svg": 679,
	"./questIcon.svg": 680,
	"./rewardLineupIcon.svg": 681,
	"./searchIcon.svg": 682,
	"./searchIconLarge.svg": 683,
	"./signOutIcon.svg": 684,
	"./star.svg": 685,
	"./tournamentIcon.svg": 686,
	"./tournamentLargeIcon.svg": 687,
	"./vipIcon.svg": 688,
	"./wheelIcon.svg": 689,
	"./wheelIconL.svg": 690,
	"./wheelIconMobile.svg": 691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 667;